/** Display metadata for the interface locales (see ./routing.ts for the list itself). */

export const LOCALE_LABELS: Record<string, string> = {
  en: "English",
  tr: "Türkçe",
  ru: "Русский",
  uz: "O'zbekcha",
};

/** Flag image for each interface locale — see `public/images/flags/README.md`.
 * Shared with the Profile page's own (custom-styled) language picker so the
 * two controls draw from one source of truth. */
export const LOCALE_FLAGS: Record<string, string> = {
  en: "/images/flags/gb.svg",
  tr: "/images/flags/tr.svg",
  ru: "/images/flags/ru.svg",
  uz: "/images/flags/uz.svg",
};
